import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCustomerList(params) {
  return request({
    url: URL.partner.customer,
    method: 'get',
    params
  })
}

export function saveCustomer(data) {
  return request({
    url: URL.partner.customer,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function getCustomer(params) {
  return request({
    url: URL.partner.getCustomer,
    method: 'get',
    params
  })
}

// 查收合作伙伴所对应的服务
export function findCustomerServiceByNameApi(partnerId, serviceType) {
  return request({
    url: URL.partner.customerService + '?partnerId=' + encodeURIComponent(partnerId) + '&serviceType=' + encodeURIComponent(serviceType),
    method: 'get'
  })
}

// 委托单位列表查询
export function queryCustomerPageable(params) {
  return request({
    url: URL.partner.queryCustomerPageable,
    method: 'get',
    params
  })
}

// 新增委托单位
export function saveTenant(data) {
  return request({
    url: URL.partner.saveTenant,
    method: 'post',
    data
  })
}

// 删除委托单位
export function delCustomer(data) {
  return request({
    url: URL.partner.delCustomer,
    method: 'post',
    data
  })
}
